var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"font-weight-light"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"8","offset-md":"2"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }